import { parseJsonField } from './parseJsonField';

export const parseSessionAnalysisFields = (session) => {
  const rationale = parseJsonField(session?.overall_sentiment_rationale);
  const topics = parseJsonField(session?.overall_sentiment_topics);

  const intent =
    session?.primary_intent ||
    topics?.primary_intent ||
    topics?.primary_category ||
    null;

  const status = session?.intent_fulfilled
    ? (session.intent_fulfilled === 'true'
      ? 'resolved'
      : (session.intent_fulfilled === 'partial' ? 'partially_resolved' : 'unresolved'))
    : (session?.resolution_status || null);

  const priority = session?.priority_band || session?.business_risk || null;
  const effort = session?.effort_score ?? session?.intensity_score ?? null;
  const loop = session?.no_progress_loop ?? session?.loop_detected ?? false;
  const delta = session?.delta_open_to_close ?? session?.delta_valence ?? null;
  const tags = Array.isArray(session?.tags) ? session.tags : null;

  return {
    rationale,
    topics,
    intent,
    status,
    priority,
    effort,
    loop,
    delta,
    tags,
    failedRecovery: session?.failed_recovery ?? rationale?.failed_recovery ?? false,
    unsupportedPromise: session?.unsupported_promise ?? rationale?.unsupported_promise ?? false,
    turningPoint: session?.turning_point || rationale?.turning_point || null
  };
};
